import React from 'react';
import { Layout } from './Layout';

export const FormLayout = ({ title, description, children, onSubmit, footer, hideLayout=false }) => {
  return (
    <Layout hideLayout={hideLayout}>
        
    <form
      onSubmit={onSubmit}
      className=" mx-auto h-full bg-[var(--bg-card)] text-[var(--text-primary)] p-6 md:p-8 rounded-xl shadow-md space-y-6"
    >
      <div>
        <h1 className="text-2xl font-semibold">{title}</h1>
        {description && (
          <p className="mt-1 text-[var(--text-secondary)] text-sm">{description}</p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {children}
      </div>

      <div className="absolute bottom-10 right-10 ">
        <div className=' flex justify-end items gap-3 pt-4'>
{footer}
        </div>
        
      </div>
    </form>
</Layout>
  );
};
